import React from 'react';
import { navy } from '@zocdoc/branding/colors';
import styled from 'styled-components';

import { Icon } from './_base';

const SettingsSVG = styled(Icon).attrs({ viewBox: '0 0 38 40' })``;

const Settings = ({ color = navy, ...props }) => (
    <SettingsSVG
        data-test="settings-icon"
        {...props}
    >
        <g fill={color}>
            <path d="m19.2 11c-5.1 0-9.2 4.1-9.2 9.2s4.1 9.2 9.2 9.2 9.2-4.1 9.2-9.2-4.1-9.2-9.2-9.2zm0 14.6c-3 0-5.5-2.4-5.5-5.4s2.4-5.4 5.5-5.4c3 0 5.5 2.4 5.5 5.4s-2.5 5.4-5.5 5.4z" />
            <path d="m38 16h-4.7c-0.6-2.2-1.8-4.2-3.3-5.8l3.1-3.1-2.6-2.6-3.4 3.3c-2.1-1.3-4.5-2.2-7.2-2.3v-5.5h-4v5.8c-1.7 0.4-3.3 1.1-4.7 2l-3.2-3.4-2.7 2.7 3.1 3.1c-1.5 1.7-2.7 3.6-3.3 5.9h-5.1v4h4.5v0.1c0 3.2 1 6.1 2.7 8.5l-3.4 3.3 2.6 2.6 3.3-3.3c1.8 1.5 3.9 2.6 6.3 3.1v5.6h4v-5.2c3.3-0.2 6.3-1.4 8.7-3.5l3.4 3.4 2.6-2.6-3.5-3.5c1.7-2.4 2.7-5.3 2.7-8.4v-0.1h4.1v-4.1zm-18.8 15.1c-6.1 0-11-4.9-11-11s4.9-11 11-11 11 4.9 11 11-5 11-11 11z" />
        </g>
    </SettingsSVG>
);

export {
    Settings as default,
    Settings,
};
